<template>
    <header>
        <a href="http://linyouquan.net/" target="_blank" class="down">下载APP</a>
        <div class="wechatBox">
          <span class="wechat">官方微信</span>
          <!-- 二维码 -->
          <div class='codeBox'>
            <img v-if="isdb" class="code" src="@/assets/imgs/db.jpg" alt="">
            <p class="txt">扫一扫关注公众号</p>
          </div>
        </div>
        <!-- <a href="javascript:;">北京 &nbsp;晴 &nbsp;4℃ &nbsp;17℃</a> -->
        <!-- <div class="rightNews" v-if="title=='个人中心'">
            <a href="javascript:;" class="ftBtn">发帖</a>
            <img class="avatar" src="@/assets/imgs/qq.png" alt="">
            <a href="javascript" class="username">用户名</a>
        </div> -->
    </header>
</template>
<script>
export default {
    props:['isdb'],
    data() {
        return {
            title:''
        }
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/index.less';
    header{
        padding:0 120px 0 20px;
        height: 34px;
        line-height: 34px;
        font-size:@ft14;
        background:@bggray;
        position: relative;
        a{
            color:#fff;
            &.down{
                padding-right:20px;
                display: inline-block;
                margin:0 20px 0 0;
                border-right:1px solid #494949;
            }
        }
        .wechatBox{
          position: relative;
          display: inline-block;
          &:hover{
            .codeBox{
              display: block;
            }
          }
        }
        .wechat{
          color:#fff;
          cursor: pointer;
        }
        .codeBox{
          box-shadow:0 0 4px 0 rgba(0,0,0,0.20);
          width: 158px;
          height: 158px;
          z-index:99;
          background:#fff;
          position: absolute;
          text-align: center;
          left:-25px;
          padding:10px 0;
          display: none;
          .code{
              width:115px;
              height: 115px;
              margin:0 auto;
          }
          .txt{
              line-height:4px;
              color:#666;
          }
        }
        .rightNews{
            .fr();
            color:#fff;
            .ftBtn{
                width:62px;
                height: 100%;
                text-align: center;
                display: inline-block;
                background:#ea5d3c;
            }
            .avatar{
                width:17px;
                height: 17px;
                margin:0 9px 0 20px;
                border-radius:50%;
                vertical-align: middle;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue